// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-close-icon[data-v-45cc15c4] {\n  right: 10px;\n  top: 10px;\n  position: absolute;\n}\n.mew-dropdown-content-class[data-v-45cc15c4] {\n  border: none;\n  box-shadow: 0px 12px 12px rgba(11, 40, 64, 0.04), 0px 6px 26px rgba(11, 40, 64, 0.06), 0px 4px 48px rgba(11, 40, 64, 0.04);\n}", ""]);
// Exports
module.exports = exports;
